//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 21.07.2015.
 */

(function () {

    'use strict';

    angular.module('container.core')
        .run(createMocks);

    function createMocks($httpBackend, ENTITY_TYPE) {

        $httpBackend.whenGET(/\.html$/).passThrough();

        $httpBackend.whenGET('mock-auth/activity/administration_access').respond({
            isAllowed: true,
            isVisible: true
        });

        var tasks = [
            {
                name: 'Artis Zeego VC20',
                progress: '25',
                color: 'red'
            },
            {
                name: 'Artis Zee fms VB15',
                progress: '50',
                color: 'orange'
            },
            {
                name: 'Artis Zee cms CD10',
                progress: '75',
                color: 'green'
            },
            {
                name: 'Artis Zeego VC20',
                progress: '90',
                color: 'green'
            }
        ];

        $httpBackend.whenGET('mock-tasks').respond(tasks);

        var baseDevices = [
            {
                id: '1',
                model: 'Artis zee fms BP VA11',
                serialNumber: '45471',
                materialNumber: '10432914',
                ipAddress: '127.0.0.1',
                functionalLocation: '006-MR0037310',
                name: 'MR10432914-42145',
                product: 'AERA syngo',
                image: 'assets/img/device.png',
                country: 'United Kingdom',
                city: 'Glasgow',
                customer: 'Victoria Infirmary',
                ruhFlag: 'true',
                softwareVersion: 'MR_Aera_4VE11A',
                orderNumber: '5254408',
                operationalState: 'Active - Outbound-connected',
                registrationDate: '2014-09-18T23:41:38.507',
                latestOutboundConnection: '2015-04-15 / 13:11:23',
                latestInboundConnection: '2014-03-21 / 19:39:24',
                latestUpdateBySystem: '2015-02-25 / 03:30:58',
                createdBy: 'z023dsw / 2013-04-19 / 12:00:00',
                modifiedBy: 'z293dfg / 2015-03-10 / 12:23:42',
                fileSize: 1024,
                transferDuration: 1000
            },
            {
                id: '2',
                model: 'Artis zeego VC20',
                serialNumber: '45471',
                materialNumber: '10432914',
                ipAddress: '10.0.0.1',
                functionalLocation: '006-MR0037310',
                name: 'CT10432914-42145',
                product: 'AERA syngo',
                image: 'assets/img/device.png',
                country: 'United Kingdom',
                city: 'Glasgow',
                customer: 'Victoria Infirmary',
                ruhFlag: 'true',
                softwareVersion: 'MR_Aera_4VE11A',
                orderNumber: '5254408',
                operationalState: 'Active - Outbound-connected',
                registrationDate: '2015-09-19T23:41:38.507',
                latestOutboundConnection: '2015-04-15 / 13:11:23',
                latestInboundConnection: '2014-03-21 / 19:39:24',
                latestUpdateBySystem: '2015-02-25 / 03:30:58',
                createdBy: 'z023dsw / 2013-04-19 / 12:00:00',
                modifiedBy: 'z293dfg / 2015-03-10 / 12:23:42',
                fileSize: Math.pow(1024, 2),
                transferDuration: 60000
            },
            {
                id: '3',
                model: 'Artis zee fms CD10',
                serialNumber: '45471',
                materialNumber: '10432914',
                ipAddress: '192.168.1.1',
                functionalLocation: '006-MR0037310',
                name: 'AX10432914-42145',
                product: 'AERA syngo',
                image: 'assets/img/device.png',
                country: 'United Kingdom',
                city: 'Glasgow',
                customer: 'Victoria Infirmary',
                ruhFlag: 'true',
                softwareVersion: 'MR_Aera_4VE11A',
                orderNumber: '5254408',
                operationalState: 'Active - Outbound-connected',
                registrationDate: '2016-09-20T23:41:38.507',
                latestOutboundConnection: '2015-04-15 / 13:11:23',
                latestInboundConnection: '2014-03-21 / 19:39:24',
                latestUpdateBySystem: '2015-02-25 / 03:30:58',
                createdBy: 'z023dsw / 2013-04-19 / 12:00:00',
                modifiedBy: 'z293dfg / 2015-03-10 / 12:23:42',
                fileSize: Math.pow(1024, 3),
                transferDuration: 3600000
            },
            {
                id: '4',
                model: 'Accusam et justo',
                serialNumber: '45471',
                materialNumber: '10432914',
                ipAddress: '192.168.1.100',
                functionalLocation: '006-MR0037310',
                name: 'SY10432914-42145',
                product: 'AERA syngo',
                image: 'assets/img/device.png',
                country: 'United Kingdom',
                city: 'Glasgow',
                customer: 'Victoria Infirmary',
                ruhFlag: 'true',
                softwareVersion: 'MR_Aera_4VE11A',
                orderNumber: '5254408',
                operationalState: 'Active - Outbound-connected',
                registrationDate: '2016-09-21T23:41:38.507',
                latestOutboundConnection: '2015-04-15 / 13:11:23',
                latestInboundConnection: '2014-03-21 / 19:39:24',
                latestUpdateBySystem: '2015-02-25 / 03:30:58',
                createdBy: 'z023dsw / 2013-04-19 / 12:00:00',
                modifiedBy: 'z293dfg / 2015-03-10 / 12:23:42',
                fileSize: Math.pow(1024, 4),
                transferDuration: 86400000
            }
        ];

        var devices = [];

        _.times(5, function () {
            devices = devices.concat(_.cloneDeep(baseDevices));
        });

        devices.forEach(function (device, index) {
            device.id = index + 1;
            device.name = `${String.fromCharCode(65 + index % (90 - 65))}-${device.name}`;
        });

        $httpBackend.whenGET('mock-devices').respond(devices);

        $httpBackend.whenGET(new RegExp('mock-devices\\/[a-zA-Z0-9]+')).respond(
            function(method, url){
                var regexp = new RegExp('mock-devices\\/([a-zA-Z0-9]+)');
                var mockId = url.match(regexp)[1];
                return [200, _.find(devices, function (device) { return device.id == parseInt(mockId, 10); })];
            });



        var actions = [
            { title:'Open as Tab', url:'javascript:;' },
            { title:'Remote Connect', url:'javascript:;' },
            { title:'File Transfer', url:'javascript:;' },
            { title:'Share Network', url:'javascript:;' },
            { title:'Add to Favorite', url:'javascript:;' },
            { title:'Share', url:'javascript:;' }
        ];

        var mock = [
                { id: '1', title: 'Artis zee fms BP VA11', actions:actions },
                { id: '2', title: 'Artis zeego VC20', actions:[actions[0], actions[1]] },
                { id: '3', title: 'Artis zee fms CD10', actions:[actions[0]] },
                { id: '4', title: 'Accusam et justicia', actions:actions },
                { id: '5', title: 'Accusam et justo', actions:[actions[0]] },
                { id: '6', title: 'Lorem Ipsum', actions:actions },
                { id: '7', title: 'Dolor Sit Amet', actions:actions },
                { id: '8', title: 'Consectetur Adipiscing', actions:[actions[0], actions[1], actions[2]] },
                { id: '9', title: 'Donec accumsan', actions:actions },
                { id: '10', title: 'Feugiat Ultrices', actions:actions },
                { id: '11', title: 'Curabitur Volutpat', actions:actions },
                { id: '12', title: 'Metus Sit Amet', actions:[actions[0], actions[1], actions[2]] },
                { id: '13', title: 'Augue Semper', actions:actions },
                { id: '14', title: 'Bibendum Mauris', actions:actions },
                { id: '15', title: 'Sollicitudin', actions:actions },
                { id: '16', title: 'Vestibulum Nec Nulla', actions:actions },
                { id: '17', title: 'Eget Leo Fringilla', actions:[actions[0], actions[1]] },
                { id: '18', title: 'Consequat Risus Vitae', actions:actions },
                { id: '19', title: 'Tristique Risus', actions:actions },
                { id: '20', title: 'Vestibulum Vulputate', actions:[actions[0], actions[1]] },
                { id: '21', title: 'Lectus at Mauris', actions:[actions[0]] },
                { id: '22', title: 'Laoreet Malesuada', actions:[actions[0], actions[1]] },
                { id: '23', title: 'Fusce nec Sagittis Massa', actions:actions }
            ];

        $httpBackend.whenGET('mock-events').respond(multiplyArray(mock));
        $httpBackend.whenGET('mock-rules').respond(multiplyArray(mock));

        function multiplyArray(object) {
            var temp = [];
            var times = 10;
            for (var i=0;i<times;i++) {
                temp = temp.concat(object);
            }
            return temp;
        }

        $httpBackend.whenGET(new RegExp('mock-devices\\/.+')).respond(
            function(method, url){
                var regexp = new RegExp('mock-devices\\/(.+)');
                var searchText = url.match(regexp)[1].toString();
                searchText = searchText.replace(/%20/g, " ");
                return [200, multiplyArray(
                    _.filter(mock, function (device) { return device.title.toLowerCase().indexOf(searchText.toLowerCase())>-1 })
                )];
            });

        $httpBackend.whenGET(new RegExp('mock-events\\/.+')).respond(
            function(method, url){
                var regexp = new RegExp('mock-events\\/(.+)');
                var searchText = url.match(regexp)[1].toString();
                searchText = searchText.replace(/%20/g, " ");
                return [200, multiplyArray(
                    _.filter(mock, function (event) { return event.title.toLowerCase().indexOf(searchText.toLowerCase())>-1 })
                )];
            });
        $httpBackend.whenGET(new RegExp('mock-rules\\/.+')).respond(
            function(method, url){
                var regexp = new RegExp('mock-rules\\/(.+)');
                var searchText = url.match(regexp)[1].toString();
                searchText = searchText.replace(/%20/g, " ");
                return [200, multiplyArray(
                    _.filter(mock, function (rule) { return rule.title.toLowerCase().indexOf(searchText.toLowerCase())>-1 })
                )];
            });



        var entities = [
            {
                type: ENTITY_TYPE.DEVICE,
                serialNumber: '45471',
                materialNumber: '10432914'
            },
            {
                type: ENTITY_TYPE.EVENT,
                eventId: '1080'
            }
        ];

        $httpBackend.whenGET('mock-entities').respond(entities);

        var remoteConnectTools = [
            {
                name: 'VNC',
                icon: 'vnc.png'
            },
            {
                name: 'Teamviewer',
                icon: 'teamviewer.png'
            },
            {
                name: 'HTTP',
                icon: 'http.png'
            },
            {
                name: 'FTP',
                icon: 'ftp.png'
            }
        ];

        $httpBackend.whenGET('mock-remote-connect-tools').respond(remoteConnectTools);

        ['GET', 'HEAD', 'DELETE', 'POST', 'PUT', 'PATCH', 'JSONP'].forEach(function (method) {
            $httpBackend.when(method, /./).passThrough();
        });
    }
})();